<template>
  <div class="dashboard p-4">
    <div class="mt-1 w-full">
      <div
        class="flex grid-cols-2 space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <h2 class="mt-3 font-bold text-lg text-gray-800 dark:text-gray-200">
            Your Profile
          </h2>
        </div>
        <div>
          <router-link :to='"/user/config"' class="h-9">
              <div class="">
                <div style="height: 46px;width: 46px;" class="flex items-center justify-center hover:bg-orange-500 flex-1 h-full p-2 bg-yellow1 text-white shadow rounded-lg">
                  <div class="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                    </svg>
                  </div>
                </div>
              </div>
            </router-link>
        </div>
      </div>
    </div>
    <div>
      <div class="dark:text-gray-200 space-y-2">
        <div class="flex">
          <span class="w-28 font-medium">Name</span>
          <span>: {{ dataUser.name }}</span>
        </div>
        <div class="flex">
          <span class="w-28 font-medium">Email</span>
          <span>: {{ dataUser.email }}</span>
          <button v-if="!dataUser?.isVerified" v-on:click="sendCodeHandler"
            class="ml-4 bg-blue-500 text-white px-4 py-0 rounded hover:bg-blue-600">
            Verify
          </button>
        </div>
        <div class="flex">
          <span class="w-28 font-medium">Share Data</span>
          <span>: {{ dataUser.range == 0? "-": dataUser.range == 1? "Weekly":"Montly" }}</span>
        </div>
      </div>
    </div>
    <div
      class="mt-3 bg-white dark:bg-gray-800 p-5 w-full rounded-md box-border border dark:border-gray-700"
    >
      <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
        Table list all user
      </h2>
      <p class="text-gray-700 font-lexend font-sm dark:text-gray-200">
        Total User : {{ dataAllUser.length }}
      </p>
      <div class="wrapping-table mt-10">
        <table
          class="w-full text-sm text-left text-gray-500 dark:text-gray-400 lg:overflow-auto overflow-x-scroll"
        >
          <thead
            class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
          >
            <tr>
              <th
                scope="col"
                class="uppercase px-1 py-3"
              >
                No
              </th>
              <th
                scope="col"
                class="uppercase px-1 py-3"
              >
                Name
              </th>
              <th
                scope="col"
                class="uppercase px-1 py-3"
              >
                Email
              </th>
              <th
                scope="col"
                class="uppercase px-6 py-3"
              >
                Last Online
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 odd:bg-white even:bg-gray-50"
              v-for="(items, i) in dataAllUser"
              :key="items.id"
            >
              <td class="px-1 py-4">
                {{ i+1 }}
              </td>
              <td class="px-1 py-4">
                {{ items.name }}
              </td>
              <td class="px-1 py-4">
                {{ items.email }}
              </td>
              <td class="px-6 py-4">
                {{ formattedDateTime(items.lastLogin) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <Modal
    title="Verify your email"
    btnTextSubmit="Submit"
    btnType="submit"
    btnText="Add Group"
    :btnShow="false"
    :isOpenEx="openModal"
    :footerShow="false"
    @updateOpen="openModal=false"
  >
    <template v-slot:body>
      <div v-if="isLoading">
        <Vue3Lottie :animationData="loading" :height="200" :width="200" />
      </div>
      <div v-else>
        <div v-if="isSucces">
        <Vue3Lottie :animationData="succes" :height="200"  />
      </div>
        <div v-else class="space-y-5 pb-5">
            <div class="flex justify-center">
                <div class="bg-white dark:bg-gray-800 rounded-xl border dark:border-gray-700 shadow dark:shadow-inner p-4 sm:p-8 mx-4 max-w-sm">
                    <svg class="w-6 h-6 mb-4 text-gray-800 dark:text-gray-200" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path
                            class="dark:fill-gray-200"
                            d="M1.94631 9.31555C1.42377 9.14137 1.41965 8.86034 1.95706 8.6812L21.0433 2.31913C21.5717 2.14297 21.8748 2.43878 21.7268 2.95706L16.2736 22.0433C16.1226 22.5718 15.8179 22.5901 15.5946 22.0877L12.0002 14.0002L18.0002 6.00017L10.0002 12.0002L1.94631 9.31555Z">
                        </path>
                    </svg>
                    <h1 class="font-bold text-2xl text-gray-800 dark:text-gray-100 mb-1">Check your email</h1>
                    <p class="text-sm font-medium text-gray-600 dark:text-gray-400">We've sent a code to {{ dataUser.email }}</p>
                    <div class="mt-6">
                        <form>
                            <div v-if="isLoading2">
                              <Vue3Lottie :animationData="loading1" :height="112"  />
                            </div>
                            <div v-else>
                              <div class="flex items-center justify-center">
                                <input
                                  v-model="code"
                                  type="text"
                                  placeholder="- - - -"
                                  maxlength="4"
                                  class="w-full h-16 border dark:bg-gray-500 rounded-lg p-4 text-center mx-auto hover:border-blue-200 focus:outline-none focus:ring focus:ring-blue-400 placeholder:font-medium font-bold text-xl text-blue-900 dark:text-gray-100"
                                />
                              </div>
                              <p class="text-center m-5 text-red-600 text-lg">{{ textError }}</p>
                            </div>
                            <div
                                class="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2 justify-between mx-auto w-full mt-6 mb-4">
                                <button type="reset" v-on:click="openModal=false"
                                    class="w-full py-2.5 px-4 font-semibold border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300 text-sm rounded-lg hover:text-gray-900 dark:hover:text-white hover:border-gray-400 dark:hover:border-gray-500">
                                    Cancel
                                </button>
                                <button type="submit" v-on:click.prevent="verifyCodeHandler"
                                    class="w-full py-2.5 bg-blue-600 dark:bg-blue-500 px-4 font-semibold text-gray-50 dark:text-gray-100 text-sm rounded-lg hover:bg-blue-800 dark:hover:bg-blue-700 hover:text-white">
                                    Verify
                                </button>
                            </div>
                        </form>
                    </div>
                    <small class="text-center block text-xs text-gray-600 dark:text-gray-400 font-medium"
                    >
                      Didn't get a code? 
                      <a href="" v-on:click.prevent="sendCodeHandler" class="underline font-semibold text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-500">Click to resend</a></small>
                </div>
            </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
  import { useCounterStore } from "@/store/counter";
  import { mapActions, mapState } from "pinia";
  import { Icon } from "@iconify/vue";
  import Modal from "@/components/modal.vue";
  import { Vue3Lottie } from 'vue3-lottie';
  import loading from "../assets/loading10.json"
  import loading1 from "../assets/loading9.json"
  import succes from "../assets/succes1.json"

  export default {
    name: "List User",
    data() {
      return {
        openModal: false,
        loading, loading1, succes,
        isLoading: true,
        msgRes: '',
        code: '',
        textError: '',
        isLoading2: false,
        isSucces: false
      };
      // end chart data line
    },
    components: {
      Icon, Modal
      , Vue3Lottie
    },
    methods: {
      ...mapActions(useCounterStore,['getDataUser','getDataAllUser','sendCode','verifyCode']),
      async verifyCodeHandler(){
        this.isLoading2 = true
        this.textError = ''
        const check = await this.verifyCode(this.code)
        if(check !== true){
          this.textError = check
          this.isLoading2= false
        } else {
          await this.getDataUser()
          this.isLoading2= false
          this.isSucces = true
          setInterval(() => {
            this.openModal = false
          }, 3000);
        }
      },
      async sendCodeHandler(){
        this.code = ''
        this.openModal = true
        this.isLoading = true
        const check = await this.sendCode()
        if(check !== true){
          this.msgRes = check
        }
        this.isLoading = false
      },
      formattedDateTime(time) {
        if (time) {
          const options = { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric' };
          const indonesiaDate = new Date(time).toLocaleString('id-ID', options);
          return indonesiaDate.replace(',', '')+' WIB';
        }
        return '';
      }
    },
    created(){
      this.getDataUser()
      this.getDataAllUser()
    },
    computed: {
      ...mapState(useCounterStore,['dataUser','dataAllUser'])
    },
    mounted() {}
  };
</script>
